var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 160 160"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-bell_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.052 121.253H130.9c5.044 0 8.1-2.671 8.1-6.653 0-6.313-6.209-11.849-11.496-17.385-4.754-5.099-5.481-15.491-6.306-24.378-.825-22.144-7.179-37.781-23.332-43.268C95.732 21.265 89.377 15 80.5 15S65.27 21.265 63.134 29.569c-16.153 5.487-22.507 21.124-23.332 43.268-.824 8.887-1.552 19.28-6.306 24.378C28.16 102.751 22 108.287 22 114.6c0 3.982 3.056 6.653 8.052 6.653M80.5 145c10.332 0 17.706-7.479 18.724-16.025H61.776C62.746 137.521 70.168 145 80.5 145"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bell_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 15h117v130H22z"
  })))));
};
export default SvgIconBell;